import { render, staticRenderFns } from "./updateUserAttrDialog.vue?vue&type=template&id=0b830b96&scoped=true&"
import script from "./updateUserAttrDialog.vue?vue&type=script&lang=js&"
export * from "./updateUserAttrDialog.vue?vue&type=script&lang=js&"
import style0 from "./updateUserAttrDialog.vue?vue&type=style&index=0&id=0b830b96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b830b96",
  null
  
)

export default component.exports